import validation from "@/mixins/validation";
import { required, maxLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "cosmo-base-review",
    data() {
        return {
            payload: {
                last_name: "",
                name: "",
                phone: "",
                comment: "",
            },
            validationErrors: {},
            loading: false,
        }
    },
    mixins: [validation],
    validations: {
        payload: {
            last_name: { required, maxLength: maxLength(191) },
            name: { required, maxLength: maxLength(191) },
            phone: { required, maxLength: maxLength(191) },
            comment: { required },
        }
    },
    computed: {
      ...mapGetters({
        user: "profile/user",
        isAuthenticated: `auth/isAuthenticated`,
      }),
      lastNameErrors() {
            return this.computeErrors("payload", "last_name", {
                required: "validationRequired",
                maxLength: { message: "validationMax", count: 191 },
            });
        },
        nameErrors() {
            return this.computeErrors("payload", "name", {
                required: "validationRequired",
                maxLength: { message: "validationMax", count: 191 },
            });
        },
        phoneErrors() {
            return this.computeErrors("payload", "phone", {
                required: "validationRequired",
                maxLength: { message: "validationMax", count: 191 },
            });
        },
        commentErrors() {
            return this.computeErrors("payload", "comment", {
                required: "validationRequired",
            });
        },
    },
    created() {
      if (this.user && this.isAuthenticated) {
        this.payload.name = this.user.name;
        this.payload.last_name = this.user.lastName;
        this.payload.phone = this.user.phone;
      }
    },
    methods: {
        ...mapActions({
            sendSpecialCosmoBaseForm: "cosmobase/SEND_SPECIAL_COSMOBASE_FORM",
        }),
        ...mapMutations({
            changeCosmoBaseFormPopup: "popups/CHANGE_COSMOBASE_FORM_POPUP",
        }),
        async sendForm() {
            this.$v.payload.$touch();
            if (this.$v.payload.$invalid) {
                return;
            }
            this.loading = true;
            try {
                await this.sendSpecialCosmoBaseForm(this.payload);
                this.changeCosmoBaseFormPopup(false);
                this.$toasted.success("Дані успішно надіслані");
                this.payload = {
                    last_name: "",
                    name: "",
                    phone: "",
                    comment: "",
                }
            } catch (error) {
                this.validationErrors = error.data.errors;
                this.$toasted.error("Щось пішло не так, спробуйте ще раз");
            } finally {
                this.loading = false;
            }
        }
    },
}
